import React, { useState } from 'react';
import { Menu, MenuItem, Button, Box } from '@mui/material';
import { Language as LanguageIcon, ExpandMore as ExpandMoreIcon } from '@mui/icons-material';

const LanguageSelector = ({ locale, setLocale }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const languages = [
    { code: 'en', label: 'English' },
    { code: 'es', label: 'Español' },
    { code: 'fr', label: 'Français' }
  ];

  const handleMenuOpen = (event) => setAnchorEl(event.currentTarget);
  const handleMenuClose = () => setAnchorEl(null);

  const handleLanguageChange = (lang) => {
    setLocale(lang);
    setAnchorEl(null);
  };

  const currentLanguage = languages.find((lang) => lang.code === locale);

  return (
    <>
      <Button
        onClick={handleMenuOpen}
        sx={{
          color: '#00438E',
          textTransform: 'none',
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          px: 2,
          py: 1,
          borderRadius: '12px',
          backgroundColor: 'rgba(0, 67, 142, 0.08)',
          border: '1px solid rgba(0, 67, 142, 0.15)',
          fontFamily: "'Inter', 'Roboto', sans-serif",
          fontSize: '0.875rem',
          fontWeight: 500,
          transition: 'all 0.3s cubic-bezier(0.4, 0.0, 0.2, 1)',
          minWidth: 120,
          '&:hover': {
            backgroundColor: 'rgba(0, 67, 142, 0.12)',
            border: '1px solid rgba(0, 67, 142, 0.25)',
            transform: 'translateY(-1px)',
            boxShadow: '0 4px 12px rgba(0, 67, 142, 0.15)',
          },
          '&:active': {
            transform: 'translateY(0px)',
          }
        }}
      >
        <LanguageIcon sx={{ fontSize: 18, color: '#00438E' }} />
        {currentLanguage?.label || 'English'}
        <ExpandMoreIcon
          sx={{
            fontSize: 18,
            color: '#00438E',
            transition: 'transform 0.3s cubic-bezier(0.4, 0.0, 0.2, 1)',
            transform: Boolean(anchorEl) ? 'rotate(180deg)' : 'rotate(0deg)'
          }}
        />
      </Button>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        sx={{
          mt: 1,
          '& .MuiPaper-root': {
            borderRadius: '12px',
            boxShadow: '0 8px 24px rgba(0, 67, 142, 0.12), 0 2px 8px rgba(0, 0, 0, 0.08)',
            minWidth: 160,
            backgroundColor: 'rgba(255, 255, 255, 0.98)',
            backdropFilter: 'blur(20px)',
            border: '1px solid rgba(0, 67, 142, 0.1)',
            overflow: 'hidden',
            py: 0.5
          }
        }}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        {languages.map((lang) => (
          <MenuItem
            key={lang.code}
            onClick={() => handleLanguageChange(lang.code)}
            selected={lang.code === locale}
            sx={{
              py: 1.5,
              px: 2.5,
              fontSize: '0.875rem',
              fontFamily: "'Inter', 'Roboto', sans-serif",
              fontWeight: lang.code === locale ? 600 : 500,
              color: lang.code === locale ? '#00438E' : '#37474F',
              backgroundColor: lang.code === locale ? 'rgba(0, 67, 142, 0.08)' : 'transparent',
              transition: 'all 0.2s ease',
              borderLeft: lang.code === locale ? '3px solid #00438E' : '3px solid transparent',
              '&:hover': {
                backgroundColor: 'rgba(0, 67, 142, 0.08)',
                borderLeft: '3px solid #00438E',
                transform: 'translateX(2px)',
              },
              '&.Mui-selected': {
                backgroundColor: 'rgba(0, 67, 142, 0.08)',
              },
              '&.Mui-selected:hover': {
                backgroundColor: 'rgba(0, 67, 142, 0.12)',
              }
            }}
          >
            {lang.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default LanguageSelector;
